// extracted by mini-css-extract-plugin
module.exports = {"viewMyAcct":"purify_index__viewMyAcct--3kORf","icon":"purify_index__icon--1cT3o","text":"purify_index__text--3Wdrl"};